var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24,30 L30,30 L30,14 L24,14 L24,30 Z M22,12 L22,14 L22,30 L10,30 L10,8 L10,6 L10,2 L22,2 L22,12 Z M2,30 L8,30 L8,8 L2,8 L2,30 Z M30,12 L28,12 L28,11 C28,10.448 27.554,10 27,10 C26.446,10 26,10.448 26,11 L26,12 L24,12 L24,2 C24,0.894 23.104,0 22,0 L10,0 C8.896,0 8,0.894 8,2 L8,6 L6,6 L6,5 C6,4.448 5.554,4 5,4 C4.446,4 4,4.448 4,5 L4,6 L2,6 C0.896,6 0,6.894 0,8 L0,30 C0,31.106 0.896,32 2,32 L10,32 L22,32 L30,32 C31.104,32 32,31.106 32,30 L32,14 C32,12.894 31.104,12 30,12 L30,12 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26 18L28 18 28 16 26 16zM26 22L28 22 28 20 26 20zM14 8L16 8 16 6 14 6zM14 12L16 12 16 10 14 10zM14 16L16 16 16 14 14 14zM4 12L6 12 6 10 4 10zM4 16L6 16 6 14 4 14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.bc67dbca.svg";
export { ForwardRef as ReactComponent };